import { OrUndefined } from '../../../foundation/js/optional';
import { BasicNodeSubWire } from './basic-node-sub.wire';

import * as Lodash from 'lodash';

function addItem(sub: BasicNodeSubWire, { child }: { child: string }): void {
  sub.push(child);
}

function removeItem(sub: BasicNodeSubWire, { child }: { child: string }): void {
  Lodash.remove(sub, (c) => c === child);
}

function insertItemBeforeItem(sub: BasicNodeSubWire, { child, before }: { child: string; before: string }): void {
  const index = sub.findIndex((c) => c === before);
  if (index === -1) {
    return;
  }
  sub.splice(index, 0, child);
}

function insertItemAfterItem(sub: BasicNodeSubWire, { child, after }: { child: string; after: string }): void {
  const index = sub.findIndex((c) => c === after);
  if (index === -1) {
    return;
  }
  sub.splice(index + 1, 0, child);
}

function getPrevItem(sub: BasicNodeSubWire, { child }: { child: string }): OrUndefined<string> {
  const index = sub.findIndex((c) => c === child);
  if (index <= 0) {
    return;
  }
  return sub[index - 1];
}

export const BasicNodeSubWireFuncs = {
  addItem,
  removeItem,
  insertItemBeforeItem,
  insertItemAfterItem,
  getPrevItem,
};
